export default "__VITE_ASSET__C3RFvQJ7__"